import { useTokenStore } from './../../storage/tokenState';
import { useInfiniteQuery, useQuery, useQueryClient } from "react-query";
import { getCommonApiWithTokenPostMethod, getCommonApiWithToken } from "../commonApi";
import { API_ROUTES } from "../../constant";
import { useContext, useEffect, useMemo, useState } from 'react';
import TransactionHistoryContext from '../../context/TransactionHistory';


const usePassbookApi = (PayloadDataState: any) => {
    const { token } = useTokenStore();
    const queryClient = useQueryClient();

    const extraHeaders = {
        'Content-Type': 'application/json',
    }

  const { data, isLoading, isError, error, status, refetch, isFetching } = useQuery({
    queryKey: ['passbook'],
    queryFn: () => getCommonApiWithTokenPostMethod(API_ROUTES.REFERRAL_GET_PASSBOOK_TRANSACTION_HISTORY, token?.accessToken || '', PayloadDataState, extraHeaders),
    enabled: !!PayloadDataState && !!token?.accessToken,
    cacheTime: 0,
    staleTime: 0
  });

  return { data, isLoading, isError, error, status, refetch, isFetching };
};

export default usePassbookApi;

export const usePassbookApiPrevContent = () => {
    const { token } = useTokenStore();
    const { setPayloadDataState, PayloadDataState, fetchFirstPage, setFetchFirstPage, tabChange, setTabChange } = useContext(TransactionHistoryContext);

    const extraHeaders = {
        'Content-Type': 'application/json',
    }

    //const memoizedPayload = useMemo(() => PayloadDataState, [PayloadDataState]);

  const { data, isLoading, isError, error, status, refetch, isFetching, fetchNextPage, hasNextPage, isFetchingNextPage, isSuccess } = useInfiniteQuery({
    queryKey: ['passbook'],
    queryFn: async ({pageParam}) => {
        const dynamicPayload = {
            ...PayloadDataState ,
            ...(pageParam?.walletLastSelectedItem && {walletLastSelectedItem: pageParam.walletLastSelectedItem}),
            ...(pageParam?.walletLastSelectedTime && {walletLastSelectedTime: pageParam.walletLastSelectedTime})
          }; 
          ((tabChange !== true) && await setPayloadDataState(dynamicPayload));
          await setTabChange(false);
        return getCommonApiWithTokenPostMethod(API_ROUTES.REFERRAL_GET_PASSBOOK_TRANSACTION_HISTORY, token?.accessToken || '', dynamicPayload, extraHeaders)
    },
    enabled: !!token?.accessToken,
    cacheTime: 0, 
    staleTime: 0,               // always fresh
    refetchOnWindowFocus: false,
    keepPreviousData: false,
    onSuccess: async (data: any) => { 
        if(fetchFirstPage){
            const transOuter = data?.pages[0]?.response?.data;
            const dynamicPayload = {
                ...PayloadDataState ,
            ...(transOuter?.walletLastSelectedItem && {walletLastSelectedItem: transOuter?.walletLastSelectedItem}),
            ...(transOuter?.walletLastSelectedTime && {walletLastSelectedTime: transOuter.walletLastSelectedTime})
          };
          ((tabChange !== true) && await setPayloadDataState(dynamicPayload));
          await setTabChange(false);
          await setFetchFirstPage(false);
        }
    },
    getNextPageParam: (lastPage, pages) => {
        const transactions = lastPage?.response?.data ?? [];
        //const hasMore = lastPage?.response?.data?.hasNextPage;
        //if (!hasMore || transactions.length === 0) return undefined;
        //const lastTransaction = transactions[transactions.length - 1];

        if (lastPage?.response?.data?.transactions?.length === 0) return undefined;
 
        return {walletLastSelectedItem: transactions?.walletLastSelectedItem, walletLastSelectedTime: transactions?.walletLastSelectedTime};

        //return lastPage.response.data.nextPage;
    }
  });

  return { data, isLoading, isError, error, status, refetch, isFetching, fetchNextPage, hasNextPage, isFetchingNextPage };
};



export const usePassbookFiltersApi = () => {
    const { token } = useTokenStore();

    const extraHeaders = {
        'Content-Type': 'application/json',
    }

    const { data, isLoading, isError, error, status } = useQuery({
        queryKey: ['passbookFilters'],
        queryFn: () => getCommonApiWithToken(API_ROUTES.REFERRAL_GET_PASSBOOK_TRANSACTION_HISTORY_FILTERS, token?.accessToken || ''),
        enabled: !!token?.accessToken,
    });

    return { data, isLoading, isError, error, status };
}



export const useTranscationHistoryFilters = () => {
   // const { token } = useTokenStore();
    const { PayloadDataState, setLoading, setTransactionHistoryFilters, setError, transactionHistoryFilters } = useContext(TransactionHistoryContext);
    const { token } = useTokenStore();

    const filterFunction = async () => {
   
        if(!token?.accessToken){
            setError("No token found");
            return;
        }
    setLoading(true);

    try {
        const  dataRes = await getCommonApiWithToken(API_ROUTES.REFERRAL_GET_PASSBOOK_TRANSACTION_HISTORY_FILTERS, token?.accessToken || '').then((res) => {
            setLoading(false);
            return res;
        });
        setTransactionHistoryFilters(dataRes);
    } catch (error) {
        setLoading(false);
        setError(error);
        console.log("error", error);
    } 

}

    return { filterFunction };


}


export const usePassbookApiNextContent = () => {
    const { token } = useTokenStore();
    const { PayloadDataState, setTransactionHistory, transactionHistory, setLoading, setError, loadMore, setLoadMore, setWalletLastSelectedItemState, setWalletLastSelectedTimeState,remainCount, setRemainCount } = useContext(TransactionHistoryContext);

    const extraHeaders = {
        'Content-Type': 'application/json',
    }

    const nextContentFunction = async () => {
        if(!token?.accessToken){
            setError("No token found");
            return;
        }
        setLoading(true);
        try {
            const dataRes = await getCommonApiWithTokenPostMethod(API_ROUTES.REFERRAL_GET_PASSBOOK_TRANSACTION_HISTORY, token?.accessToken || '', PayloadDataState, extraHeaders).then((res) => {
               // setLoading(false);
                return res;
            });
            setRemainCount(dataRes?.response?.data?.count);
            setWalletLastSelectedItemState(dataRes?.response?.data?.walletLastSelectedItem);
            setWalletLastSelectedTimeState(dataRes?.response?.data?.walletLastSelectedTime);

            if(loadMore){
                //console.log("here2");
                setTransactionHistory([...transactionHistory, ...dataRes?.response?.data?.transactions]);
                
             }else{
                //console.log("here3");
                setTransactionHistory(dataRes?.response?.data?.transactions);
             }
             setLoading(false);
        } catch (error) {
            setLoading(false);
            setError(error);
            setLoadMore(false);
            console.log("error", error);
        }
    }

    return { nextContentFunction };
}
